 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"9b9373bd39164850050b7f646e556385e66d0db4","1":"055ca895f51fff4563937c5ccf9b1009bef7de31","2":"ceef5ee72ab243a7de6539e8a156c87894432621","3":"55635cc1d5db10ba58579da9652b270f65062140","4":"43686a8adb42fd05e6ce83d8fce6d450e589ffe6","5":"7390d24a3eb14421b98b676349696fde8910a2b3","6":"ece13722d931e102d53264df3b84ac78ae51f4f7","7":"f78d415170b0919798ae95600e714a34f928f3cd","8":"12d887768f3790979fa158977ae092e2920fb659","9":"3d3c51fb670f9f9d7f20cc1a135807bd9828601d","10":"a16763ab28df39ecd4ff2fba87eb4c07845a8f2f","11":"bc1b873232b3fe4ed8704299139af7ad5f18cfc7","12":"d4f1cbe54caf5958f920da2f04999452c730519d","13":"framework","16":"2c796e83","19":"component---src-pages-404-js","20":"component---src-templates-bundle-landing-page-js","21":"component---src-templates-bundling-incentive-page-js","22":"component---src-templates-contentful-freeform-article-js","23":"component---src-templates-contentful-policies-page-js","24":"component---src-templates-discount-page-js","25":"component---src-templates-ingredients-map-js","26":"component---src-templates-ingredients-page-js","27":"component---src-templates-product-page-js","28":"component---src-templates-routes-approach-js","29":"component---src-templates-routes-articles-js","30":"component---src-templates-routes-build-a-bundle-js","31":"component---src-templates-routes-cart-js","32":"component---src-templates-routes-clinical-study-js","33":"component---src-templates-routes-gift-js","34":"component---src-templates-routes-index-js","35":"component---src-templates-routes-ingredients-js","36":"component---src-templates-routes-login-js","37":"component---src-templates-routes-press-js","38":"component---src-templates-routes-reviews-js","39":"component---src-templates-routes-shop-vitamins-js","40":"component---src-templates-routes-signup-js","41":"component---src-templates-shop-landing-page-js"}[chunkId]||chunkId) + "-" + {"0":"20a03919cd40d0329d4e","1":"9760a2b27800d61fc240","2":"a7a455c889c17fcea5a2","3":"32c8b4af7d386ec46d7f","4":"a5362a1fc401e4083ea4","5":"6984e0b856cec4c74906","6":"82c3205b98cc2e20b3ed","7":"55f4f55d550e7bfb6c2a","8":"9311e3605ff4a15608af","9":"1128fe4b682bf77d860b","10":"f55ed34cac58aa442c31","11":"2b2af9d63f78779a0c1f","12":"3cc6fac16830ce6e85a0","13":"7647a58d250a597ef329","16":"fe0d54f9a4c4ed9d89c7","19":"c4d8d9932a44f0b8626a","20":"977367b00a881efb6e8d","21":"9a8af771494f5952023d","22":"e6f3854cdc65e707c12f","23":"2ff38e8ee756cf8d0d2d","24":"45327c76d13b96727a19","25":"bfe786ea12e52fe3c526","26":"08bc0ab16bce653190f5","27":"5aaba2a6205d914cd233","28":"2aef19ca4d3eca2de4c4","29":"0088fb1f3a99eb07b8d1","30":"89a26f3e9167956a564f","31":"2bd404d6b1d9c163789b","32":"b2e6b48b17d34a4cb7be","33":"159743ce903774d7c41a","34":"5f7f10bbfbcba16080d0","35":"7400333bcf0bd694ff88","36":"e7ee93d7821263c4953f","37":"f42fa5058b41491d3373","38":"8fe3f37614e88fefe753","39":"014a62ce7ab9c40cc1f0","40":"d71ea1b8c06c84a01c35","41":"f59d1df5aeefaaf860ce"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
